// extracted by mini-css-extract-plugin
module.exports = {"controlContainer":"widget-demo--controlContainer--1F4XU","controlItem":"widget-demo--controlItem--3vKLB","button":"widget-demo--button--ZURsb"};